import React from 'react';
import { NotificationContainer } from '../../Common/Notifications';
import { NotificationVariant } from '../../Common/Notifications/types';

interface HipaaProps {
  installed?: boolean;
}

export const DisplayHipaaBanner: React.FC<HipaaProps> = ({ installed }): JSX.Element => {
  return (
    <div>
      {!installed ? (
        <NotificationContainer
          notificationData={{
            title: '',
            body: 'hipaa.error_banner',
            variant: NotificationVariant.Blue,
          }}
          notificationProperties={{
            closeTimer: false,
            closeable: true
          }}
        />
      ) : (
        <NotificationContainer
          notificationData={{
            title: '',
            body: 'hipaa.error_installed_apps_banner',
            variant: NotificationVariant.Blue,
          }}
          notificationProperties={{
            closeable: true,
            closeTimer: false
          }}
        />
      )}
    </div>
  );
};
